export const headerLogoNorthumberland = {
    path: '/style/images/seven360/estar/ehcp_header_logo_2.png',
    height: '65px',
    width: '300px',
    marginTop: '10px',
    title: 'EHCP Management System',
    subtitle: 'Northumberland County Council',
}

export const passportNorthumberlandMenu = [
    { type: 'dropdown', title: 'Options', id: '"basic-nav-dropdown"', items: [
            { type: 'item', href: "/EHCP_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
            { type: 'divider' },
            { type: 'item', href: "?logout", text: 'Logout' },
        ] },
]

export const loginParams = {
    backgroundColor: 'rgb(215, 219, 234)',
    panelBackground: 'linear-gradient(rgb(56, 85, 123) 48.65%, rgb(66, 112, 171) 89%)',
    panelTextColor: 'white',
    iconColor: 'white',
    logo: '/style/images/seven360/estar/estar_ncc_logo.png',
    logoWidth: '220px',
    loginButtonStyle : {
        height: '2.3rem',
        borderStyle: 'none',
        backgroundColor: '#db1415',
        marginTop: '0.5rem',
    },
    loginContentWrapperClass: 'ehcp',
    subtitle: 'EHCP Management System',
    subtitleStyle : {
        textAlign: 'center',
        color: 'white',
        marginBottom: '20px',
        fontSize: 'larger',
    },
    showProvider: false,
    suppressSchool360Notes: true,
}
